import menuItems from 'menu-items';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AdminAccessLevel, AdminRoleTeamMember } from 'store/constant';
import { filtersPage, PermissionTypes } from './constants';
import { SET_PAGE_PERMISSIONS } from 'store/Authentication/actions';

const PermissionWrapper = ({ children }) => {
    const { pagePermissions, permissions } = useSelector((state) => state.authentication);
    const { userPermissions, teamMemberRole } = permissions;
    const dispatch = useDispatch('');
    const checkCustomRoleActivated = () => {
        const updatedPermissionsSet = { ...pagePermissions };
        userPermissions.forEach((permission) => {
            const key = PermissionTypes[permission.name];
            if (key) {
                if (permission.acessType === AdminAccessLevel.FULL) {
                    if (key === PermissionTypes.diologIntegration) {
                        updatedPermissionsSet[PermissionTypes.webform].hasEditPermission = true;
                        updatedPermissionsSet[PermissionTypes.webform].hasViewPermission = true;
                        updatedPermissionsSet[PermissionTypes.emailExtension].hasEditPermission = true;
                        updatedPermissionsSet[PermissionTypes.emailExtension].hasViewPermission = true;
                    }
                    if (key === PermissionTypes.companyDetails) {
                        updatedPermissionsSet[PermissionTypes.executiveTeam].hasEditPermission = true;
                        updatedPermissionsSet[PermissionTypes.executiveTeam].hasViewPermission = true;
                    }
                    updatedPermissionsSet[key].hasEditPermission = true;
                    updatedPermissionsSet[key].hasViewPermission = true;
                } else if (permission.acessType === AdminAccessLevel.VIEW) {
                    if (key === PermissionTypes.diologIntegration) {
                        updatedPermissionsSet[PermissionTypes.webform].hasEditPermission = false;
                        updatedPermissionsSet[PermissionTypes.webform].hasViewPermission = true;
                        updatedPermissionsSet[PermissionTypes.emailExtension].hasEditPermission = false;
                        updatedPermissionsSet[PermissionTypes.emailExtension].hasViewPermission = true;
                    }
                    if (key === PermissionTypes.companyDetails) {
                        updatedPermissionsSet[PermissionTypes.executiveTeam].hasEditPermission = false;
                        updatedPermissionsSet[PermissionTypes.executiveTeam].hasViewPermission = true;
                    }
                    updatedPermissionsSet[key].hasEditPermission = false;
                    updatedPermissionsSet[key].hasViewPermission = true;
                } else if (permission.acessType === AdminAccessLevel.NONE) {
                    if (key === PermissionTypes.diologIntegration) {
                        updatedPermissionsSet[PermissionTypes.webform].hasEditPermission = false;
                        updatedPermissionsSet[PermissionTypes.webform].hasViewPermission = false;
                        updatedPermissionsSet[PermissionTypes.emailExtension].hasEditPermission = false;
                        updatedPermissionsSet[PermissionTypes.emailExtension].hasViewPermission = false;
                    }
                    if (key === PermissionTypes.companyDetails) {
                        updatedPermissionsSet[PermissionTypes.executiveTeam].hasEditPermission = false;
                        updatedPermissionsSet[PermissionTypes.executiveTeam].hasViewPermission = false;
                    }
                    updatedPermissionsSet[key].hasEditPermission = false;
                    updatedPermissionsSet[key].hasViewPermission = false;
                }
            }
        });
        return updatedPermissionsSet;
    };

    function updatePermissions(noAccessPermission, addOnlyViewPermission) {
        const updatedPermissionSet = { ...pagePermissions };

        for (const key in updatedPermissionSet) {
            if (!noAccessPermission.includes(key) && !addOnlyViewPermission?.includes(key)) {
                updatedPermissionSet[key].hasEditPermission = true;
                updatedPermissionSet[key].hasViewPermission = true;
            }
            if (addOnlyViewPermission?.includes(key)) {
                updatedPermissionSet[key].hasEditPermission = false;
                updatedPermissionSet[key].hasViewPermission = true;
            }
            if (noAccessPermission?.includes(key)) {
                if (filtersPage.includes(key)) updatedPermissionSet[key].hasEditPermission = false;
                updatedPermissionSet[key].hasViewPermission = false;
            }
        }

        return updatedPermissionSet;
    }
    useEffect(() => {
        let pathName = '';
        const newMenus = [
            ...menuItems.items,
            { id: PermissionTypes.calendar },
            { id: PermissionTypes.diologIntegration },
            { id: PermissionTypes.webform },
            { id: PermissionTypes.emailExtension },
            { id: PermissionTypes.executiveTeam },
            { id: PermissionTypes.companyDetails }
        ];
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .map((id) =>
                [...newMenus].find((menuItem) => {
                    let foundItem = menuItem.id === id ? menuItem : undefined;
                    if (!foundItem) {
                        foundItem = menuItem?.children?.find((item) => item.id === id);
                    }
                    if (foundItem) pathName = foundItem.id;
                    return foundItem;
                })
            );
        let updatedPermissions = {};
        if (currentIndex.length) {
            switch (teamMemberRole) {
                case AdminRoleTeamMember.ADMIN:
                    updatedPermissions = updatePermissions([], []);
                    break;
                case AdminRoleTeamMember.MEMBER:
                    updatedPermissions = updatePermissions([], [PermissionTypes.myTeam]);
                    break;
                case AdminRoleTeamMember.VIEWER:
                    updatedPermissions = updatePermissions(
                        [''],
                        [
                            PermissionTypes.myTeam,
                            PermissionTypes.questionBoard,
                            PermissionTypes.questionRegistries,
                            PermissionTypes.announcements,
                            PermissionTypes.diologIntegration,
                            PermissionTypes.webform,
                            PermissionTypes.emailExtension,
                            PermissionTypes.calendar,
                            PermissionTypes.executiveTeam,
                            PermissionTypes.companyDetails
                        ]
                    );
                    break;
                case AdminRoleTeamMember.CUSTOM:
                default:
                    updatedPermissions = checkCustomRoleActivated(pathName);
                    break;
            }
        }
        //This functions checks that page permission is not same
        if (JSON.stringify(updatedPermissions) !== JSON.stringify(pagePermissions)) {
            dispatch({ type: SET_PAGE_PERMISSIONS, pagePermissions: updatedPermissions });
            localStorage.setItem('pagePermissions', updatedPermissions);
        }
    }, [userPermissions, teamMemberRole, pagePermissions]);
    return <>{teamMemberRole ? children : null}</>;
};
export default PermissionWrapper;
